export default __webpack_public_path__ + "static/media/yeezyh1.0b00c451.jpg";